// extracted by mini-css-extract-plugin
export var button = "ComponentHero-module--button--57898";
export var heading = "ComponentHero-module--heading--9c777";
export var image = "ComponentHero-module--image--83b05";
export var section = "ComponentHero-module--section--9492f";
export var subheading = "ComponentHero-module--subheading--23033";